/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: ingestion.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateIngestionRequest,
  CreateIngestionResponse,
  DeleteIngestionRequest,
  DeleteIngestionResponse,
  GetIngestionRequest,
  GetIngestionResponse,
  ListIngestionsRequest,
  ListIngestionsResponse,
  SetIngestionInputRequest,
  SetIngestionInputResponse,
  SetIngestionStartTimeRequest,
  SetIngestionStartTimeResponse,
} from '../types/ingestion';

export const createIngestionService = (transport: Transport) => ({
  async createIngestion(
    request: CreateIngestionRequest,
    options: RequestOptions = {},
  ): Promise<CreateIngestionResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.IngestionService.CreateIngestion, {
      organization_id,
      program_id,
    });
    return transport.post<CreateIngestionResponse>(url, body, options);
  },

  async setIngestionInput(
    request: SetIngestionInputRequest,
    options: RequestOptions = {},
  ): Promise<SetIngestionInputResponse> {
    const { organization_id, program_id, ingestion_id, ...body } = request;
    const url = getApiPath(API_METHODS.IngestionService.SetIngestionInput, {
      organization_id,
      program_id,
      ingestion_id,
    });
    return transport.post<SetIngestionInputResponse>(url, body, options);
  },

  async setIngestionStartTime(
    request: SetIngestionStartTimeRequest,
    options: RequestOptions = {},
  ): Promise<SetIngestionStartTimeResponse> {
    const { organization_id, program_id, ingestion_id, ...body } = request;
    const url = getApiPath(API_METHODS.IngestionService.SetIngestionStartTime, {
      organization_id,
      program_id,
      ingestion_id,
    });
    return transport.post<SetIngestionStartTimeResponse>(url, body, options);
  },

  async deleteIngestion(
    request: DeleteIngestionRequest,
    options: RequestOptions = {},
  ): Promise<DeleteIngestionResponse> {
    const { organization_id, program_id, ingestion_id } = request;
    const url = getApiPath(API_METHODS.IngestionService.DeleteIngestion, {
      organization_id,
      program_id,
      ingestion_id,
    });
    return transport.delete<DeleteIngestionResponse>(url, options);
  },

  async getIngestion(
    request: GetIngestionRequest,
    options: RequestOptions = {},
  ): Promise<GetIngestionResponse> {
    const { organization_id, program_id, ingestion_id } = request;
    const url = getApiPath(API_METHODS.IngestionService.GetIngestion, {
      organization_id,
      program_id,
      ingestion_id,
    });
    return transport.get<GetIngestionResponse>(url, options);
  },

  async listIngestions(
    request: ListIngestionsRequest,
    options: RequestOptions = {},
  ): Promise<ListIngestionsResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.IngestionService.ListIngestions, {
      organization_id,
      program_id,
    });
    return transport.get<ListIngestionsResponse>(url, { params, ...options });
  },
});

export type IngestionService = ReturnType<typeof createIngestionService>;
